import React, {useContext, useEffect, useState} from 'react';
import {FormattedMessage} from "react-intl";

// Local Components
import MobileView from "./components/MobileView";
import HandOverScanShipmentPopup from "./components/HandOverScanShipmentPopup";
import DesktopView from "./components/DesktopView";
import SuccessToast from "../components/SuccessToast";
import HandOverShipmentPopup from "./components/HandOverShipmentPopup";

// API
import {list} from 'api/shipment/list';
import {getPlaces} from 'api/wms/wmsPlaces/list';

// Context
import {WMSContext} from "../../context/WMSContext";
import {ClickAndCollectHandOverContext} from "./context/ClickAndCollectHandOverContext";

// Utils
import {UserAgentUtils} from "utils/useragent";
import {LineItemStatus} from "utils/LineItemStatus";
import {ShipmentStatus} from "utils/ShipmentStatus";
import {getWMSContainers, getWMSContainersWithType} from "../../../../api/wms/wmsContainers/wmsContainers";
import {WmsContainerType} from "../../../../utils/WMSContainerType";
import {WmsItemsStatus} from "../../../../utils/WmsItemsStatus";
import {BarCodeScannerContext} from "../../../../contexts/barCodeScannerContext";
import WrongShipmentToast from "../components/WrongShipmentToast";

function ClickAndCollectHandHover() {
    const {currentInventory} = useContext(WMSContext)
    const {scannedString, setEnableScan} = useContext(BarCodeScannerContext)

    const [shipments, setShipments] = React.useState([]);
    const [containers, setContainers] = useState([])

    const [response, setResponse] = React.useState(null);

    const [totalPages, setTotalPages] = React.useState(0);
    const [itemsPerPage] = React.useState(10);

    const [actualLink, setActualLink] = React.useState(null);
    const [previousLink, setPreviousLink] = React.useState(null);
    const [nextLink, setNextLink] = React.useState(null);

    const [searchString, setSearchString] = React.useState('');

    const [selectedShipment, setSelectedShipment] = React.useState(null);
    const [selectedContainer, setSelectedContainer] = useState(null)

    const [openHandOverScanShipmentPopup, setOpenHandOverScanShipmentPopup] = React.useState(false);
    const [openHandOverShipmentPopup, setOpenHandOverShipmentPopup] = React.useState(false);
    const [openToast, setOpenToast] = React.useState(false);
    const [openWrongShipmentScannedToast, setOpenWrongShipmentScannedToast] = React.useState(false);

    const [sort, setSort] = React.useState({ orderBy: 'date', orderDirection: 'asc' });

    const title = "wms.cc.list.handOver.title"
    const subtitle = "wms.cc.list.handOver.subtitle"

    // equivalent to componentDidMount
    useEffect(() => {
        if (!currentInventory) {
            return;
        }
        getShipments();
        getWMSContainersWithType(WmsContainerType.CC, currentInventory.id).then((response) => setContainers(response))
    }, [currentInventory])

    useEffect(() => {
        if (!response) {
            return;
        }

        setShipments(response["hydra:member"]);

        setTotalPages(Math.ceil(response['hydra:totalItems'] / itemsPerPage));

        setActualLink(response['hydra:view']?.['@id'].replace('/shipments?', ''));
        setPreviousLink(response['hydra:view']?.['hydra:previous']?.replace('/shipments?', ''));
        setNextLink(response['hydra:view']?.['hydra:next']?.replace('/shipments?', ''));
    }, [response]);


    useEffect(() => {
        if (!currentInventory) return;

        const handler = setTimeout(() => {
            getShipments(createLink(1, searchString));
        }, 1000);

        return () => clearTimeout(handler);
    }, [searchString, currentInventory, selectedContainer, sort]);

    function createLink(page = 1, searchString = '') {
        // Shipments must have CC type containers, CC WMSItems (status = click_collect_ready and container is CC type)
        //  and lineItem in to-ship or confirmed
        const params = {
            inventoryId: currentInventory.id,
            'groups[]': 'wms_shipment:read',
            pagination: true,
            itemsPerPage: itemsPerPage,
            page: page,
            lineItemStatus: [LineItemStatus.TO_SHIP, LineItemStatus.CONFIRMED],
            status: ShipmentStatus.READY_TO_BE_SHIPPED,
            shipmentContainerType: [WmsContainerType.CC],
        }

        // Shipments can be with or without wmsItems (specialOrders), that's why we don't check for the presence of wmsItems.

        if (searchString) {
            params.search = encodeURIComponent(searchString);
        }

        if (selectedContainer) {
            params['wmsContainer'] = selectedContainer;
        }

        switch (sort.orderBy) {
            case 'date':
                params['order[createdAt]'] = sort.orderDirection;
                break;
            case 'wmsContainer':
                params['order[container.name]'] = sort.orderDirection;
                break;
            case 'name':
                params['order[order.customerShippingLastname]'] = sort.orderDirection;
                break;
            default:
                break;
        }

        return new URLSearchParams(params).toString();
    }

    function getShipments(link = createLink()) {
        list(link).then((res) => {
            setResponse(res);
        })
    }

    function onPageChange(page) {
        getShipments(createLink(page));
    }

    function refreshShipments() {
        getShipments(actualLink);
    }

    function handleRequestSort(property)  {
        setSort((prev) => {
            if (prev.orderBy === property) {
                // Inverse la direction si on clique sur la même colonne
                return {
                    orderBy: property,
                    orderDirection: prev.orderDirection === 'asc' ? 'desc' : 'asc',
                };
            } else {
                // Nouvelle colonne commence par 'desc'
                return {
                    orderBy: property,
                    orderDirection: 'desc',
                };
            }
        });
    }

    useEffect(() => {
        if (scannedString && 0 < scannedString.length) {
            shipments.map(shipment => {
                if (shipment.wmsBarcode === scannedString) {
                    setSelectedShipment(shipment)
                    setOpenHandOverShipmentPopup(true)
                } else {
                    setOpenWrongShipmentScannedToast(true)
                }
            })
        }
    }, [scannedString]);

    return (
        <ClickAndCollectHandOverContext.Provider value={{
            title,
            subtitle,
            shipments,
            selectedShipment,
            setSelectedShipment,
            containers,
            selectedContainer,
            setSelectedContainer,
            searchString,
            setSearchString,
            onPageChange,
            getShipments,
            refreshShipments,
            nextLink,
            previousLink,
            totalPages,
            sort,
            setSort,
            openToast: () => setOpenToast(true),
            handleRequestSort,
            setOpenHandOverScanShipmentPopup
        }}>
            {UserAgentUtils.isMobile() ? (
                <MobileView />
            ) : (
                <DesktopView />
            )}
            {openHandOverScanShipmentPopup && !!selectedShipment && (
                <HandOverScanShipmentPopup
                    onClick={() => {
                        setOpenHandOverShipmentPopup(true);
                        setOpenHandOverScanShipmentPopup(false);
                    }}
                    onClose={() => setOpenHandOverScanShipmentPopup(false)}
                />
            )}
            {openHandOverShipmentPopup && !!selectedShipment && (
                <HandOverShipmentPopup onClose={() => setOpenHandOverShipmentPopup(false)}/>
            )}
            <SuccessToast
                title={<FormattedMessage id={'wms.cc.handover.toast.title'}/>}
                isOpen={openToast}
                handleClose={() => setOpenToast(false)}
            />

            <WrongShipmentToast
                title={<FormattedMessage id={'wms.cc.handover.wrongShipment.toast.title'}/>}
                subtitle={<FormattedMessage id={'wms.cc.handover.wrongShipment.toast.subtitle'}/>}
                isOpen={openWrongShipmentScannedToast}
                handleClose={() => setOpenWrongShipmentScannedToast(false)}
            />

        </ClickAndCollectHandOverContext.Provider>
    )
}

export default ClickAndCollectHandHover;
